import React from "react";
import { useFieldArray, useForm } from "react-hook-form";
import {
	EditorComponent,
	Input,
	Textarea,
} from "../../components/shared/FormComponentsNew";
import {
	Accordion,
	AccordionBody,
	AccordionHeader,
	AccordionItem,
	Col,
	Row,
	UncontrolledAccordion,
} from "reactstrap";
import { useState } from "react";
import ImageUpload from "./ImageUpload";
import { useEffect } from "react";
import ImagesUpload from "./ImagesUpload";

const StatisticsArray = ({ control, register, errors, setValue, watch }) => {
	const { fields, append, remove } = useFieldArray({
		control,
		name: "sections",
	});

	const [open, setOpen] = useState("1");
	const toggle = id => {
		if (open === id) {
			setOpen();
		} else {
			setOpen(id);
		}
	};

	return (
		<div className="form-group branches features  ">
			<Row>
				<Accordion open={open} toggle={toggle}>
					<AccordionItem>
						<AccordionHeader targetId="1">
							<h5>اقسام الصفحة</h5>{" "}
						</AccordionHeader>
						<AccordionBody accordionId="1">
							{fields.map((item, index) => (
								<Section
									key={index}
									{...{
										item,
										register,
										errors,
										control,
										setValue,
										remove,
										index,
										watch,
									}}
								/>
							))}
							<button
								type="button"
								className="bt bt-success mt-2"
								onClick={() => {
									append({ type: "image" });
								}}
							>
								اضافة قسم
							</button>
						</AccordionBody>
					</AccordionItem>
				</Accordion>
			</Row>
		</div>
	);
};

// ============================================================================================

const Section = ({
	item,
	register,
	errors,
	control,
	setValue,
	remove,
	index,
	watch,
}) => {
	const namePrefix = `sections.${index}`;
	const [picture, setPicture] = useState(item?.image);

	const [open, setOpen] = useState("1");
	const toggle = id => {
		if (open === id) {
			setOpen();
		} else {
			setOpen(id);
		}
	};

	useEffect(() => {
		setValue(`${namePrefix}.image`, picture);
	}, [namePrefix, picture, setValue]);

	const {
		fields: rows,
		append: appendRow,
		remove: removeRow,
	} = useFieldArray({
		control,
		name: `${namePrefix}.table.rows`,
	});
	const {
		fields: columns,
		append: appendCol,
		remove: removeCol,
	} = useFieldArray({
		control,
		name: `${namePrefix}.table.columns`,
	});

	return (
		<Col xs={12}>
			<div className="add-multi-component card card-body bg-light bg-opacity-50 mt-2">
				<Row>
					<Col>
						<Input
							type="radio"
							langId="النوعية : صورة افقية"
							name={`${namePrefix}.type`}
							register={register}
							errors={errors}
							value="image"
							className=""
							wrapperStyle="d-flex flex-row-reverse gap-1"
						/>
					</Col>
					<Col>
						<Input
							type="radio"
							langId="النوعية : صور رأسية"
							name={`${namePrefix}.type`}
							register={register}
							errors={errors}
							value="vertical-images"
							className=""
							wrapperStyle="d-flex flex-row-reverse gap-1"
						/>
					</Col>
					<Col>
						<Input
							type="radio"
							langId="النوعية : فيديو"
							name={`${namePrefix}.type`}
							register={register}
							errors={errors}
							value="video"
							className=""
							wrapperStyle="d-flex flex-row-reverse gap-1"
						/>
					</Col>
					<Col>
						<Input
							type="radio"
							langId="النوعية : نقاط"
							name={`${namePrefix}.type`}
							register={register}
							errors={errors}
							value="bullets"
							className=""
							wrapperStyle="d-flex flex-row-reverse gap-1"
						/>
					</Col>
				</Row>
				<Row>
					<Col xs={12} className="mb-2">
						{watch(`${namePrefix}.type`)?.includes("image") ? (
							watch(`${namePrefix}.type`) === "vertical-images" ? (
								// multipel iamges
								<ImagesUpload
									selectedImage={picture}
									setSelectedImage={setPicture}
								/>
							) : (
								<ImageUpload
									selectedImage={picture}
									setSelectedImage={setPicture}
								/>
							)
						) : watch(`${namePrefix}.type`) === "video" ? (
							<Row>
								<Input
									type="url"
									langId="رابط فيديو يوتيوب"
									name={`${namePrefix}.youtube`}
									register={register}
									errors={errors}
								/>
							</Row>
						) : (
							<Accordion open={open} toggle={toggle}>
								<AccordionItem>
									<AccordionHeader targetId="1">
										<h5 className="">نقاط الشرح</h5>
									</AccordionHeader>
									<AccordionBody accordionId="1" className="bg-secondary">
										<BulletsArray
											{...{ control, register, errors, sectionIndex: index }}
										/>
									</AccordionBody>
								</AccordionItem>
							</Accordion>
						)}
					</Col>
					<Col lg={6} xs={12}>
						<Input
							langId="العنوان"
							name={`${namePrefix}.title.ar`}
							register={register}
							errors={errors}
						/>
					</Col>
					<Col lg={6} xs={12}>
						<Input
							langId="العنوان"
							name={`${namePrefix}.title.en`}
							register={register}
							errors={errors}
						/>
					</Col>
				</Row>
				<Row>
					<Col lg={6} xs={12}>
						<EditorComponent
							langId="الوصف"
							name={`${namePrefix}.description.ar`}
							control={control}
							errors={errors}
							key={index}
							index={index}
						/>
					</Col>
					<Col lg={6} xs={12}>
						<EditorComponent
							langId="الوصف"
							name={`${namePrefix}.description.en`}
							control={control}
							errors={errors}
							key={index}
							index={index}
						/>
					</Col>
				</Row>
				{watch(`${namePrefix}.type`)?.includes("image") && (
					<Row>
						<Input
							type="checkbox"
							langId="قائمة بيانات "
							name={`${namePrefix}.tableFlag`}
							register={register}
							errors={errors}
							rules={{ required: false }}
							className=""
							wrapperStyle="d-inline-flex flex-row-reverse gap-1"
						/>

						{watch(`${namePrefix}.tableFlag`) === true && (
							<TableSubSection
								{...{
									register,
									errors,
									columns,
									rows,
									removeRow,
									removeCol,
									appendCol,
									appendRow,
									namePrefix,
								}}
							/>
						)}
					</Row>
				)}
				<button
					type="button"
					onClick={() => remove(index)}
					className="removeImg"
				>
					<i className="fas fa-trash"></i>
				</button>
			</div>
		</Col>
	);
};

const TableSubSection = ({
	register,
	errors,
	columns,
	rows,
	removeRow,
	removeCol,
	appendCol,
	appendRow,
	namePrefix,
}) => {
	return (
		<>
			<div className="table-wrp">
				<table>
					<thead>
						{(columns || [])?.map((item, index) => (
							<th key={index}>
								<div>
									<button
										type="button"
										className="btn"
										onClick={() => {
											removeCol(index);
										}}
									>
										<i className="fas fa-times-circle"></i>
									</button>
									<Input
										placeholder="اسم العامود"
										name={`${namePrefix}.table.columns.${index}`}
										register={register}
										rules={{ required: false }}
										errors={errors}
										labelClass="mb-0"
									/>
								</div>
							</th>
						))}
						{rows?.length > 0 && <th>حذف صف</th>}
					</thead>
					<tbody>
						{(rows || [])?.map((item, rowIndex) => (
							<tr key={rowIndex}>
								{(columns || [])?.map((item, colIndex) => (
									<td>
										<div>
											<Input
												placeholder="قيمة الصف"
												name={`${namePrefix}.table.values[${colIndex}][${rowIndex}]`}
												register={register}
												rules={{ required: false }}
												errors={errors}
												labelClass="mb-0"
											/>
										</div>
									</td>
								))}
								<td>
									<button
										type="button"
										className="btn"
										onClick={() => {
											removeRow(rowIndex);
										}}
									>
										<i className="fas fa-times"></i>
									</button>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
			<div className="d-flex mt-3 gap-2">
				<button
					type="button"
					className="bt bt-sm bt-success"
					onClick={() => appendCol(" ")}
				>
					<i className="fas fa-plus"></i> اضافة اعمدة
				</button>
				<button
					type="button"
					className="bt bt-sm bt-primary"
					onClick={() => appendRow(" ")}
				>
					<i className="fas fa-plus"></i> اضافة صف
				</button>
			</div>
		</>
	);
};

const BulletsArray = ({ control, register, errors, sectionIndex }) => {
	const namePrefix = `sections.${sectionIndex}.bullets`;

	const { fields, append, remove } = useFieldArray({
		control,
		name: "bullets",
	});

	return (
		<div className="form-group branches features ">
			{/* <div className="card-body bg-secondary"> */}
			{/* <h5 className="text-white fw-bold">نقاط الشرح</h5> */}
			<Row>
				{fields.map((item, index) => (
					<Col xl="6" xs="12" className="mt-2" key={index}>
						<div className="card card-body bg-light bg-opacity-50 mt-2">
							<Row>
								<Col lg={6} xs={12}>
									<Input
										langId="العنوان"
										name={`${namePrefix}.${index}.title.ar`}
										register={register}
										errors={errors}
									/>
								</Col>
								<Col lg={6} xs={12}>
									<Input
										langId="العنوان"
										name={`${namePrefix}.${index}.title.en`}
										register={register}
										errors={errors}
									/>
								</Col>
							</Row>
							<Row>
								<Col lg={6} xs={12}>
									<EditorComponent
										langId="الوصف"
										name={`${namePrefix}.${index}.description.ar`}
										control={control}
										errors={errors}
										key={index}
										index={index}
									/>
								</Col>
								<Col lg={6} xs={12}>
									<EditorComponent
										langId="الوصف"
										name={`${namePrefix}.${index}.description.en`}
										control={control}
										errors={errors}
										key={index}
										index={index}
									/>
								</Col>
							</Row>
							<button
								type="button"
								onClick={() => remove(index)}
								className="removeImg"
							>
								<i className="fas fa-trash"></i>
							</button>
						</div>
					</Col>
				))}
			</Row>
			<button
				type="button"
				className="bt bt-success mt-2"
				onClick={() => {
					append({});
				}}
			>
				اضافة
			</button>
			{/* </div> */}
		</div>
	);
};

export default StatisticsArray;
